import type { ReactNode } from 'react';

import { usePermissions } from '@/features/auth/usePermissions';

interface Props {
  /** A single permission, or several of which ANY grants access. */
  permission: string | string[];
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Conditionally renders on a permission.
 *
 * A UX control, NOT a security control. The API re-checks every permission on
 * every request; hiding a button here only avoids offering an action that
 * would be refused. Anything that must not happen has to be enforced server
 * side, and is.
 */
export function PermissionGate({ permission, children, fallback = null }: Props) {
  const { canAny } = usePermissions();
  const required = Array.isArray(permission) ? permission : [permission];

  return canAny(required) ? <>{children}</> : <>{fallback}</>;
}
